import { Button, DialogContent, Typography, useMediaQuery, DialogTitle } from '@mui/material';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useSignalrConnection } from 'hooks';
import { ModalTitle } from 'components';
import { HubPatient } from 'types';
import styles from './RequeueDialog.module.scss';

interface RequeueDialogProps extends DialogProps {
  patient: HubPatient | null;
  onClose: () => void;
}

export function RequeueDialog({ open, patient, onClose, ...rest }: RequeueDialogProps) {
  const { t } = useTranslation('providerRoom');
  const { enqueueSnackbar } = useSnackbar();
  const { requeuePatient } = useSignalrConnection();
  const isMobile = useMediaQuery('(max-width:600px)');

  const handleRequeue = () => {
    if (!patient) return;
    requeuePatient(patient.connectionId);
    enqueueSnackbar(t('clientRequeuedSuccessfully'), { variant: 'success' });
    onClose();
  };

  return (
    <Dialog {...rest} open={open} className={styles.dialog}>
      <DialogTitle>
        <ModalTitle title={t('requeue')} onClose={onClose} />
      </DialogTitle>
      <DialogContent className={styles.scrollableContent}>
        <Typography component='p' variant='body2' style={{ marginBottom: '.5rem' }}>
          {t('sendParticipantBackToWaitingRoom')}
        </Typography>

        <div className={styles.buttonContainer}>
          <Button variant='outlined' fullWidth className={styles.cancelButton} onClick={onClose}>
            {t('cancel')}
          </Button>
          <Button
            variant='contained'
            fullWidth
            className={styles.transferButton}
            onClick={handleRequeue}
            disabled={!patient}
          >
            {isMobile ? t('requeue') : t('yesRequeue')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
